const ITEMS = [
    "Integrity",
    "Confidentiality",
    "Professionalism",
    "Clear Communication",
    "Personal Attention",
    "South African Legal Practice",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="font-serif-display italic text-lg sm:text-xl text-[#0B192C]/70 px-8 whitespace-nowrap">
                    {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#B89047]/70" aria-hidden="true" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="values-marquee"
        className="bg-[#F6F5F2] border-y border-[#E5D7B5] py-5 overflow-hidden"
        aria-hidden="true"
    >
        <div className="flex animate-marquee w-max">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
